import {EntityBase} from "../../../shared/entity/EntityBase";

const PERSONAL_PACKAGE_GROUP_FIELDS = {
    seq: {type: parseInt, defaultValue: 0},
    groupIdx: {type: Number, defaultValue: 0},
    packageIndex: {type: Number, defaultValue: 0},
    packageName: {defaultValue: ''},
    saleType: {type: Number, defaultValue: 0},
    minAvrPayment: {type: Number, defaultValue: 0},
    maxAvrPayment: {type: Number, defaultValue: 0},
    minLevel: {type: Number, defaultValue: 0},
    maxLevel: {type: Number, defaultValue: 0},
};

export class PersonalPackageGroupEntity extends EntityBase {
    constructor(data = {}) {
        super(data, PERSONAL_PACKAGE_GROUP_FIELDS);
        this.errors = [
            {condition: () => this.packageIndex === 0, message: '패키지 인덱스를 입력하세요.'},
        ];
    }

    getIdentityKey() {
        return 'seq';
    }
}
